import { z } from "zod/v4";
import { projectTool } from "./tool-lifecycle";

export namespace AskQuestionsTool {
  const DEFAULT_DESCRIPTION =
    "Ask the user focused questions. Only call this tool once per message. When allowCustom is true, do NOT include 'Other' or similar options in the options array - the UI will automatically add a custom input option.";

  const questionSchema = z.object({
    id: z.string().describe("Unique identifier for the question"),
    label: z.string().describe("The question text to display to the user"),
    options: z
      .array(
        z.object({
          id: z.string().describe("Unique identifier for this option"),
          label: z.string().describe("The option text to display"),
        }),
      )
      .describe(
        "Available options for the user to choose from. Do NOT include 'Other' or similar options here - use allowCustom instead.",
      ),
    allowMultiple: z.boolean().optional().describe("If true, user can select multiple options"),
    allowCustom: z
      .boolean()
      .optional()
      .describe(
        "If true, an 'Other' option with a text input will be shown. Do NOT include 'Other' in options when this is true.",
      ),
  });
  const questionAnswerSchema = z.union([z.string(), z.array(z.string())]);

  const inputSchema = z.object({
    questions: z.array(questionSchema),
  });

  const outputSchema = z.object({
    answers: z
      .record(z.string(), questionAnswerSchema)
      .describe("Map of question ID to selected option ID(s) or custom text"),
  });

  export function define(description = DEFAULT_DESCRIPTION) {
    return projectTool({
      description,
      inputSchema,
      outputSchema,
      lifecycle: { continueAfterTool: true },
    });
  }
}
